import React from 'react';
import { Loading } from '../../../CommonComponents/OPL/Loading/Loading';
import { AsyncStateCard } from '../AsyncStateCard/AsyncStateCard';
import { Content, StickyFooter } from '../../../CommonComponents/OPL/StickyFooter/StickyFooter';
import { Box } from '../../../CommonComponents/OPL/Box/Box';

export const OrionRiskToleranceWorkflowLoading = () => {
  return (
    <Box minWidth={864}>
      <Content>
        <AsyncStateCard>
          <Loading text="Loading..." />
        </AsyncStateCard>
      </Content>

      <StickyFooter />
    </Box>
  );
};
